/**
 * 移动端浏览器默认进入 uni-app H5。
 * 对外统一入口：**当前域名下的 `/m/`**（生产示例：https://www.snaudit.top/m/ ）。
 * uni-app 首屏为登录页；若已有 token，登录页会进入工作台。
 * 与 public/mobile-h5-entry.js 逻辑需保持同步。
 */

export const AUDIT_PORTAL_PREFER_DESKTOP_KEY = 'audit_portal_prefer_desktop';

/** 移动端 H5 挂载路径（必须用尾部 `/`，与 Nginx `location /m/`、静态目录一致） */
export function getMobileH5MountPath() {
  return '/m/';
}

export function getMobileH5LoginHashPath() {
  return getMobileH5MountPath();
}

/** @deprecated 历史命名保留：入口即为挂载路径 */
export function getMobileH5EntryHashPath() {
  return getMobileH5MountPath();
}

export function buildMobileH5LoginUrl() {
  if (typeof window === 'undefined') return getMobileH5MountPath();
  return `${window.location.origin}${getMobileH5MountPath()}`;
}

export function buildMobileH5EntryUrl() {
  return buildMobileH5LoginUrl();
}

export function readPreferDesktopFromSearch(search) {
  const q = new URLSearchParams(search || (typeof window !== 'undefined' ? window.location.search : '') || '');
  if (q.get('desktop') === '1' || q.get('pc') === '1') return true;
  return false;
}

export function prefersDesktopPortalSession() {
  try {
    if (typeof sessionStorage === 'undefined') return false;
    return sessionStorage.getItem(AUDIT_PORTAL_PREFER_DESKTOP_KEY) === '1';
  } catch {
    return false;
  }
}

export function setPreferDesktopPortalSession(on) {
  try {
    if (typeof sessionStorage === 'undefined') return;
    if (on) sessionStorage.setItem(AUDIT_PORTAL_PREFER_DESKTOP_KEY, '1');
    else sessionStorage.removeItem(AUDIT_PORTAL_PREFER_DESKTOP_KEY);
  } catch {
    /* ignore */
  }
}

/** 从 URL 读取 desktop=1 / pc=1 时写入 session，避免站内跳转丢失偏好 */
export function syncPreferDesktopFromUrl() {
  if (typeof window === 'undefined') return;
  if (readPreferDesktopFromSearch()) {
    setPreferDesktopPortalSession(true);
  }
}

export function isStandaloneOrSpecialEntry(pathname, search) {
  const path = (pathname || '').replace(/\/+$/, '') || '/';
  const q = new URLSearchParams(search || '');
  if (q.get('standalone')) return true;
  if (q.get('demo') === '1') return true;
  if (q.get('mode') === 'webview') return true;
  if (path === '/complaint' || path === '/complaint-status') return true;
  return false;
}

export function isUnderMobileH5Mount(pathname) {
  const p = pathname || '';
  return p === '/m' || p.startsWith('/m/');
}

export function isLikelyMobilePhoneBrowser() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  if (/Electron/i.test(ua)) return false;
  if (/iPad/i.test(ua) && !/Mobile/i.test(ua)) return false;
  if (/Android/i.test(ua) && !/Mobile/i.test(ua)) return false;
  const w = typeof window !== 'undefined' ? window.innerWidth : 1024;
  const phoneUA = /iPhone|iPod|Android.*Mobile|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  const narrowMobile =
    w <= 768 && /Android|iPhone|iPod|webOS|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(ua);
  return phoneUA || narrowMobile;
}

export function shouldAutoRedirectToMobileH5Portal() {
  if (typeof window === 'undefined') return false;
  syncPreferDesktopFromUrl();
  if (prefersDesktopPortalSession()) return false;
  if (isStandaloneOrSpecialEntry(window.location.pathname, window.location.search)) return false;
  if (isUnderMobileH5Mount(window.location.pathname)) return false;
  if (!isLikelyMobilePhoneBrowser()) return false;
  return true;
}

export function redirectToMobileH5EntryIfNeeded() {
  if (!shouldAutoRedirectToMobileH5Portal()) return false;
  window.location.replace(buildMobileH5EntryUrl());
  return true;
}
